module.exports = __webpack_public_path__ + "assets/img/config-table-af44f96f.png";